import React, { useCallback, useContext, useState } from 'react'
import { Alert } from 'components'
import { Chip, RadioList } from 'components/Form'
import { Space } from 'styles/GlobalStyle'
import { CreatePracticesContext, STEPS } from './CreatePracticesContext'

const LearningUnitsAlert = (props) => {
    const { accept, close, learning_units, first_name } = props

    const { setSelectedTestTaker, setCurrentStep, learningUnitsAlert, setLearningUnitsAlert } = useContext(CreatePracticesContext)

    const [learningUnit, setLearningUnit] = useState(null)

    const handleClose = useCallback(() => {
        setLearningUnitsAlert({ open: false })
    }, [])

    const goNextStep = useCallback(() => {
        handleClose()
        setSelectedTestTaker({ ...props, learning_unit: learning_units.find(lu => lu.id == learningUnit) })
        setCurrentStep(STEPS.SELECT_ASSESSMENTS)
    }, [props, learningUnit])

    const footerActions = React.useMemo(
        () => [
            {
                label: "ביטול",
                variant: "white",
                color: "thirdly4",
                action: handleClose
            },
            {
                label: "הבא",
                className: "solid-round",
                color: "dark",
                action: goNextStep,
                disabled: !learningUnit
            },
        ], [learningUnit]
    )

    return (
        <Alert
            systemUI
            title={
                <div className='fx g10'>
                    <Chip color="lightBlue" type="icon">
                        <i class="fa-light fa-chalkboard"></i>
                    </Chip>
                    {"מסגרת לימודית"}
                </div>
            }
            footerActions={footerActions}
            handleAlert={setLearningUnitsAlert}
        >
            {`בחרו את מסגרת הלימודים עבורה תרצו להקצות את התרגולים ל${first_name}`}
            <Space />
            <RadioList
                options={learning_units}
                getLabel={(lu) => lu.display_name}
                // getLabel={({ affiliation, grade, name }) => `${affiliation} ${grade ? grade : ",קבוצה "}${name}`}
                color="thirdly"
                input={{
                    value: learningUnit,
                    onChange: setLearningUnit
                }}
            />
        </Alert>
    )
}

export default LearningUnitsAlert